export default function isOnTab(): boolean {
    return "visibilityState" in document ? "visible" === document.visibilityState : "webkitVisibilityState" in document && "visible" === (document as any).webkitVisibilityState;
}